import React from 'react'

import { Card, Icon, Skeleton, Button } from 'antd'
import PT from 'prop-types'

import SimpleBar from '../../../../../../components/charts/SimpleBar'
import { toTestId } from '../../../../../../utils/testing'

const { Meta } = Card
const headingStyles = { marginBottom: 0 }
const srOnlyStyles = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: /** @type {'absolute'} */ ('absolute'),
  whiteSpace: /** @type {'nowrap'} */ ('nowrap'),
  width: '1px',
}

const ClickFilters = ({
  data,
  description,
  disabled,
  isSalary,
  maxHeight,
  onBarClick,
  onClearFilter,
  selectedValue,
  title,
}) => {
  const actionText = selectedValue ? 'Clear' : 'Filter'
  const titleId = title
    ? `click-filter-title-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`
    : undefined
  const chartDescriptionId = titleId ? `${titleId}-chart-description` : undefined

  return (
    <div style={{ margin: '0 auto', maxWidth: 350 }}>
      {!disabled && (
        <Button
          type="link"
          className="bar-icon"
          onClick={() => onClearFilter()}
          aria-label={`${actionText} ${title} filter`}
          title={`${actionText} ${title} filter`}
          style={{ border: 'none', height: 'auto', padding: 0 }}
          disabled={disabled}
          tabIndex={disabled ? -1 : 0}
        >
          <Icon
            type={selectedValue ? 'close-circle' : 'filter'}
            theme="twoTone"
            twoToneColor={selectedValue ? '#eb2f96' : ''}
            aria-hidden="true"
          />{' '}
          {actionText}
        </Button>
      )}
      {title && (
        <Meta
          title={
            <>
              <h3 id={titleId} style={headingStyles}>
                {title}
              </h3>
              <span id={chartDescriptionId} style={srOnlyStyles}>
                bar chart
              </span>
            </>
          }
          description={description}
        />
      )}
      <Skeleton
        loading={!(data && !!data.length)}
        paragraph={{
          rows: 8,
          width: ['90%', '80%', '70%', '60%', '50%', '40%', '30%', '20%'],
        }}
        title={false}
      >
        <SimpleBar
          data={data}
          disabled={!!disabled}
          isSalary={isSalary}
          onBarClick={onBarClick}
          selectedValue={selectedValue}
          maxHeight={maxHeight}
          barColor=""
          ariaDescribedBy={chartDescriptionId}
          ariaLabelledBy={titleId}
          dataTestId={title ? `${toTestId(title)}-list` : undefined}
        />
      </Skeleton>
    </div>
  )
}

ClickFilters.propTypes = {
  data: PT.array.isRequired,
  description: PT.string,
  disabled: PT.bool,
  isSalary: PT.bool,
  maxHeight: PT.number,
  onBarClick: PT.func,
  onClearFilter: PT.func,
  selectedValue: PT.string,
  title: PT.string.isRequired,
}

export default ClickFilters
